<template>
  <div class="invoicing-list">
    <QueryFrame
      @handlePage='handlePage'
      @handlePageSize='handlePageSize'
      :count='count'
      :current="page"

    >
      <div slot="queryParams">
        <div class="queryContainer">
          <div class="queryItem" v-if="roleType!==2">
            <label>业务机构名称:</label>
            <storeListSelect class="item" v-model="query.storeIdList"></storeListSelect>
          </div>
          <div class="queryItem">
            <!-- <label>商品通用名称:</label>
            <goodsSelect class="item" v-model="query.goodsBaseIdList"></goodsSelect> -->
            <goodsSearchItem v-model="query.nameMix" ></goodsSearchItem>

          </div>
          <div class="queryItem">
            <!-- <label>商品编码:</label>
            <lk-input clearable v-model='query.goodsSerialCode' class="item" placeholder="请输入"></lk-input> -->
          </div>
          <div class="queryItem">
            <label>日期:</label>
            <timeStampDatePicker  v-model='query.startTime' class="item"></timeStampDatePicker>
          </div>
          <div class="queryItem">
            <label>至</label>
            <timeStampDatePicker  v-model='query.endTime' class="item"></timeStampDatePicker>
          </div>
           <div class="queryItem">
            <label>商品分类:</label>
            <div class="item">
              <TreeSelect v-model.trim="query.categoryIdList" :data="indicationTree" :props="{title: 'label', value: 'value', children: 'children'}"></TreeSelect>
            </div>
         </div>
          <div class="queryItem">
            <label>GSP分类:</label>
            <lk-select v-model='query.labelIdList' class="item" clearable multiple >
              <lk-option v-for="(item,index) in labels" :key="index" :value='item.id'>{{item.name}}</lk-option>
            </lk-select>
          </div>
          <div class="queryItem">
            <label>是否DTP:</label>
            <lk-select v-model='query.isDtp' class="item" clearable  >
              <lk-option :value='1'>是</lk-option>
              <lk-option :value='2'>否</lk-option>
            </lk-select>
          </div>
          <div class="queryItem">
            <label>来源:</label>
            <lk-select v-model='query.purchaseType' class="item" clearable  >
              <lk-option v-for='(item ,i) in getGoodsOrigin' :key="i" :value='item.value'>{{item.name}}</lk-option>
            </lk-select>
          </div>
          <div class="queryItem">
            <lk-button class="mr" type='primary' @click="handleSearch(false,getTotal)">查询</lk-button>
            <lk-button @click="clear">重置</lk-button>
          </div>
        </div>
      </div>
      <div slot="table">
        <div class="report-btns-wrap">
          <exportAsync  class="btn mr" @on-click='handleExport'></exportAsync>
          <lk-button type="primary" class="mr" @click='refreshTime'>刷新今日报表</lk-button>
          <div v-if="deadline">数据截止至 {{deadline}}</div>
        </div>

        <lk-row style="margin-bottom: 10px;">
          <lk-col span="24" style="padding:16px;">
            <lk-tabs type="card" v-model="queryType" @on-click="handleSearch(false,getTotal)">
              <lk-tab-pane label="按天显示" name="day">
                <div class="Report-total-container">
                  <div class="Report-total-title">合计</div>
                  <div class="Report-total-item-wrap">
                    <div class="Report-total-item-label">验收入库数量:</div>
                    <div class="Report-total-item-value">{{total.inspectionNumStr}}</div>
                  </div>
                  <div class="Report-total-item-wrap">
                    <div class="Report-total-item-label">入库金额:</div>
                    <div class="Report-total-item-value">{{total.inspectionAmountStr}}</div>
                  </div>
                  <div class="Report-total-item-wrap">
                    <div class="Report-total-item-label">退供应商数量:</div>
                    <div class="Report-total-item-value">{{total.refundNumStr}}</div>
                  </div>
                  <div class="Report-total-item-wrap">
                    <div class="Report-total-item-label">退供应商金额:</div>
                    <div class="Report-total-item-value">{{total.refundAmountStr}}</div>
                  </div>
                  <div class="Report-total-item-wrap">
                    <div class="Report-total-item-label">拆零出库数量:</div>
                    <div class="Report-total-item-value">{{total.unpackOutNumStr}}</div>
                  </div>
                  <div class="Report-total-item-wrap">
                    <div class="Report-total-item-label">拆零出库金额:</div>
                    <div class="Report-total-item-value">{{total.unpackOutAmountStr}}</div>
                  </div>
                  <div class="Report-total-item-wrap">
                    <div class="Report-total-item-label">拆零入库数量:</div>
                    <div class="Report-total-item-value">{{total.unpackInNumStr}}</div>
                  </div>
                  <div class="Report-total-item-wrap">
                    <div class="Report-total-item-label">拆零入库金额:</div>
                    <div class="Report-total-item-value">{{total.unpackInAmountStr}}</div>
                  </div>
                  <div class="Report-total-item-wrap">
                    <div class="Report-total-item-label">调拨入库数量:</div>
                    <div class="Report-total-item-value">{{total.transInNumStr}}</div>
                  </div>
                  <div class="Report-total-item-wrap">
                    <div class="Report-total-item-label">调拨入库金额:</div>
                    <div class="Report-total-item-value">{{total.transInAmountStr}}</div>
                  </div>
                  <div class="Report-total-item-wrap">
                    <div class="Report-total-item-label">调拨出库数量:</div>
                    <div class="Report-total-item-value">{{total.transOutNumStr}}</div>
                  </div>
                  <div class="Report-total-item-wrap">
                    <div class="Report-total-item-label">调拨出库金额:</div>
                    <div class="Report-total-item-value">{{total.transOutAmountStr}}</div>
                  </div>
                  <div class="Report-total-item-wrap">
                    <div class="Report-total-item-label">零售销售数量:</div>
                    <div class="Report-total-item-value">{{total.saleNumStr}}</div>
                  </div>
                  <div class="Report-total-item-wrap">
                    <div class="Report-total-item-label">零售进价金额:</div>
                    <div class="Report-total-item-value">{{total.costAmountStr}}</div>
                  </div>
                  <div class="Report-total-item-wrap">
                    <div class="Report-total-item-label">零售售价金额:</div>
                    <div class="Report-total-item-value">{{total.saleAmountStr}}</div>
                  </div>
                  <div class="Report-total-item-wrap">
                    <div class="Report-total-item-label">盘点盈亏数量:</div>
                    <div class="Report-total-item-value">{{total.stocktakingNumStr}}</div>
                  </div>
                  <div class="Report-total-item-wrap">
                    <div class="Report-total-item-label">盘点盈亏金额:</div>
                    <div class="Report-total-item-value">{{total.stocktakingAmountStr}}</div>
                  </div>
                  <div class="Report-total-item-wrap">
                    <div class="Report-total-item-label">不合格销毁数量:</div>
                    <div class="Report-total-item-value">{{total.breakageNumStr}}</div>
                  </div>
                  <div class="Report-total-item-wrap">
                    <div class="Report-total-item-label">不合格销毁金额:</div>
                    <div class="Report-total-item-value">{{total.breakageAmountStr}}</div>
                  </div>
                  <div class="Report-total-item-wrap">
                    <div class="Report-total-item-label">库存数量:</div>
                    <div class="Report-total-item-value">{{total.inventoryNumStr}}</div>
                  </div>
                  <div class="Report-total-item-wrap">
                    <div class="Report-total-item-label">库存金额:</div>
                    <div class="Report-total-item-value">{{total.inventoryAmountStr}}</div>
                  </div>
                </div>
                <lk-table border :columns='dayColumns' :data='dayTableData'></lk-table>
              </lk-tab-pane>
              <lk-tab-pane label="按品显示" name="goods">
                <div class="Report-total-container">
                  <div class="Report-total-title">合计</div>
                  <div class="Report-total-item-wrap">
                    <div class="Report-total-item-label">验收入库数量:</div>
                    <div class="Report-total-item-value">{{total.inspectionNumStr}}</div>
                  </div>
                  <div class="Report-total-item-wrap">
                    <div class="Report-total-item-label">入库金额:</div>
                    <div class="Report-total-item-value">{{total.inspectionAmountStr}}</div>
                  </div>
                  <div class="Report-total-item-wrap">
                    <div class="Report-total-item-label">退供应商数量:</div>
                    <div class="Report-total-item-value">{{total.refundNumStr}}</div>
                  </div>
                  <div class="Report-total-item-wrap">
                    <div class="Report-total-item-label">退供应商金额:</div>
                    <div class="Report-total-item-value">{{total.refundAmountStr}}</div>
                  </div>
                  <div class="Report-total-item-wrap">
                    <div class="Report-total-item-label">拆零出库数量:</div>
                    <div class="Report-total-item-value">{{total.unpackOutNumStr}}</div>
                  </div>
                  <div class="Report-total-item-wrap">
                    <div class="Report-total-item-label">拆零出库金额:</div>
                    <div class="Report-total-item-value">{{total.unpackOutAmountStr}}</div>
                  </div>
                  <div class="Report-total-item-wrap">
                    <div class="Report-total-item-label">拆零入库数量:</div>
                    <div class="Report-total-item-value">{{total.unpackInNumStr}}</div>
                  </div>
                  <div class="Report-total-item-wrap">
                    <div class="Report-total-item-label">拆零入库金额:</div>
                    <div class="Report-total-item-value">{{total.unpackInAmountStr}}</div>
                  </div>
                  <div class="Report-total-item-wrap">
                    <div class="Report-total-item-label">调拨入库数量:</div>
                    <div class="Report-total-item-value">{{total.transInNumStr}}</div>
                  </div>
                  <div class="Report-total-item-wrap">
                    <div class="Report-total-item-label">调拨入库金额:</div>
                    <div class="Report-total-item-value">{{total.transInAmountStr}}</div>
                  </div>
                  <div class="Report-total-item-wrap">
                    <div class="Report-total-item-label">调拨出库数量:</div>
                    <div class="Report-total-item-value">{{total.transOutNumStr}}</div>
                  </div>
                  <div class="Report-total-item-wrap">
                    <div class="Report-total-item-label">调拨出库金额:</div>
                    <div class="Report-total-item-value">{{total.transOutAmountStr}}</div>
                  </div>
                  <div class="Report-total-item-wrap">
                    <div class="Report-total-item-label">零售销售数量:</div>
                    <div class="Report-total-item-value">{{total.saleNumStr}}</div>
                  </div>
                  <div class="Report-total-item-wrap">
                    <div class="Report-total-item-label">零售售价金额(含税):</div>
                    <div class="Report-total-item-value">{{total.saleAmountStr}}</div>
                  </div>
                  <div class="Report-total-item-wrap">
                    <div class="Report-total-item-label">零售售价金额(不含税):</div>
                    <div class="Report-total-item-value">{{total.saleAmountWithoutTaxStr}}</div>
                  </div>
                  <div class="Report-total-item-wrap">
                    <div class="Report-total-item-label">盘点盈亏数量:</div>
                    <div class="Report-total-item-value">{{total.stocktakingNumStr}}</div>
                  </div>
                  <div class="Report-total-item-wrap">
                    <div class="Report-total-item-label">盘点盈亏金额:</div>
                    <div class="Report-total-item-value">{{total.stocktakingAmountStr}}</div>
                  </div>
                  <div class="Report-total-item-wrap">
                    <div class="Report-total-item-label">不合格销毁数量:</div>
                    <div class="Report-total-item-value">{{total.breakageNumStr}}</div>
                  </div>
                  <div class="Report-total-item-wrap">
                    <div class="Report-total-item-label">不合格销毁金额:</div>
                    <div class="Report-total-item-value">{{total.breakageAmountStr}}</div>
                  </div>
                  <div class="Report-total-item-wrap">
                    <div class="Report-total-item-label">库存数量:</div>
                    <div class="Report-total-item-value">{{total.inventoryNumStr}}</div>
                  </div>
                  <div class="Report-total-item-wrap">
                    <div class="Report-total-item-label">库存金额:</div>
                    <div class="Report-total-item-value">{{total.inventoryAmountStr}}</div>
                  </div>
                </div>
                <lk-table border :columns='goodsColumns' :data='goodsTableData'></lk-table>
              </lk-tab-pane>
            </lk-tabs>
          </lk-col>
        </lk-row>
      </div>
    </QueryFrame>
  </div>
</template>
<script>
import reportService from '@/services/report';
import QueryFrame from '../../components/frame/QueryFrame.vue';
import utils from '../../libs/utils';
import mapState from '../../mixins/mapState'; // 鉴权
import queryMixins from '../../mixins/queryMixins';
import exportAsync from '../../components/report/ExportAsync.vue';
// import goodsSelect from '../../components/report/GoodsSelect.vue';
import reportMixin from './reportMixin.js';
import TreeSelect from '../../components/treeSelect/treeSelect.vue';

export default {
  name: 'invoicingReportList',
  mixins: [mapState, queryMixins, reportMixin],
  components: {
    QueryFrame, exportAsync, TreeSelect,
  },
  data() {
    return {
      query: {
        startTime: utils.getCurrentMonthTimestamp(),
        endTime: utils.getNextMonthTimestamp(),
        goodsBaseIdList: [],
        storeIdList: [],
        goodsSerialCode: '',
      },
      total: {},
      queryType: 'day',
      dayColumns: [
        {
          title: '序号',
          minWidth: 60,
          render: (h, { index }) => h('div', index + 1),
        },
        {
          title: '日期',
          key: 'createTime',
          minWidth: 116,
        },
        {
          title: '业务机构',
          key: 'goodsStoreVoStoreCode',
          minWidth: 116,
        },
        {
          title: '业务机构名称',
          key: 'goodsStoreVoStoreName',
          minWidth: 116,
        },
        {
          title: '商品编码',
          key: 'goodsStoreVoGoodsSerialCode',
          minWidth: 116,
        },
        {
          title: '来源',
          key: 'purchaseTypeName',
          minWidth: 116,
        },
        {
          title: '商品通用名称',
          key: 'goodsStoreVoGoodsApprovedName',
          minWidth: 116,
        },
        {
          title: '规格',
          key: 'goodsStoreVoSpec',
          minWidth: 116,
        },
        {
          title: '生产企业',
          key: 'goodsStoreVoProducer',
          minWidth: 116,
        },
        {
          title: '产地',
          key: 'goodsStoreVoOrigin',
          minWidth: 116,
        },
        {
          title: '单位',
          key: 'goodsStoreVoMinPkgUnitName',
          minWidth: 116,
        },
        {
          title: '验收入库数量',
          key: 'inspectionNumStr',
          minWidth: 116,
        },
        {
          title: '入库金额',
          key: 'inspectionAmountStr',
          minWidth: 116,
        },
        {
          title: '退供应商数量',
          key: 'refundNumStr',
          minWidth: 116,
        },
        {
          title: '退供应商金额',
          key: 'refundAmountStr',
          minWidth: 116,
        },
        {
          title: '拆零出库数量',
          key: 'unpackOutNumStr',
          minWidth: 116,
        },
        {
          title: '拆零出库金额',
          key: 'unpackOutAmountStr',
          minWidth: 116,
        },
        {
          title: '拆零入库数量',
          key: 'unpackInNumStr',
          minWidth: 116,
        },
        {
          title: '拆零入库金额',
          key: 'unpackInAmountStr',
          minWidth: 116,
        },
        {
          title: '调拨入库数量',
          key: 'transInNumStr',
          minWidth: 116,
        },
        {
          title: '调拨入库金额',
          key: 'transInAmountStr',
          minWidth: 116,
        },
        {
          title: '调拨出库数量',
          key: 'transOutNumStr',
          minWidth: 116,
        },
        {
          title: '调拨出库金额',
          key: 'transOutAmountStr',
          minWidth: 116,
        },
        {
          title: '零售销售数量',
          key: 'saleNumStr',
          minWidth: 116,
        },
        {
          title: '零售进价金额',
          key: 'costAmountStr',
          minWidth: 116,
        },
        {
          title: '零售售价金额',
          key: 'saleAmountStr',
          minWidth: 116,
        },
        {
          title: '盘点盈亏数量',
          key: 'stocktakingNumStr',
          minWidth: 116,
        },
        {
          title: '盘点盈亏金额',
          key: 'stocktakingAmountStr',
          minWidth: 116,
        },
        {
          title: '不合格销毁数量',
          key: 'breakageNumStr',
          minWidth: 116,
        },
        {
          title: '不合格销毁金额',
          key: 'breakageAmountStr',
          minWidth: 116,
        },
        {
          title: '库存数量',
          key: 'inventoryNumStr',
          minWidth: 116,
        },
        {
          title: '库存金额',
          key: 'inventoryAmountStr',
          minWidth: 116,
        },
      ],
      goodsColumns: [
        {
          title: '序号',
          minWidth: 60,
          render: (h, { index }) => h('div', index + 1),
        },
        {
          title: '日期',
          key: 'date',
          minWidth: 116,
        },
        {
          title: '业务机构',
          key: 'goodsStoreVoStoreCode',
          minWidth: 116,
        },
        {
          title: '业务机构名称',
          key: 'goodsStoreVoStoreName',
          minWidth: 116,
        },
        {
          title: '商品编码',
          key: 'goodsStoreVoGoodsSerialCode',
          minWidth: 116,
        },
        {
          title: '来源',
          key: 'purchaseTypeName',
          minWidth: 116,
        },
        {
          title: '商品通用名称',
          key: 'goodsStoreVoGoodsApprovedName',
          minWidth: 116,
        },
        {
          title: '规格',
          key: 'goodsStoreVoSpec',
          minWidth: 116,
        },
        {
          title: '生产企业',
          key: 'goodsStoreVoProducer',
          minWidth: 116,
        },
        {
          title: '产地',
          key: 'goodsStoreVoOrigin',
          minWidth: 116,
        },
        {
          title: '单位',
          key: 'goodsStoreVoMinPkgUnitName',
          minWidth: 116,
        },
        {
          title: '验收入库数量',
          key: 'inspectionNumStr',
          minWidth: 116,
        },
        {
          title: '入库金额',
          key: 'inspectionAmountStr',
          minWidth: 116,
        },
        {
          title: '退供应商数量',
          key: 'refundNumStr',
          minWidth: 116,
        },
        {
          title: '退供应商金额',
          key: 'refundAmountStr',
          minWidth: 116,
        },
        {
          title: '拆零出库数量',
          key: 'unpackOutNumStr',
          minWidth: 116,
        },
        {
          title: '拆零出库金额',
          key: 'unpackOutAmountStr',
          minWidth: 116,
        },
        {
          title: '拆零入库数量',
          key: 'unpackInNumStr',
          minWidth: 116,
        },
        {
          title: '拆零入库金额',
          key: 'unpackInAmountStr',
          minWidth: 116,
        },
        {
          title: '调拨入库数量',
          key: 'transInNumStr',
          minWidth: 116,
        },
        {
          title: '调拨入库金额',
          key: 'transInAmountStr',
          minWidth: 116,
        },
        {
          title: '调拨出库数量',
          key: 'transOutNumStr',
          minWidth: 116,
        },
        {
          title: '调拨出库金额',
          key: 'transOutAmountStr',
          minWidth: 116,
        },
        {
          title: '零售销售数量',
          key: 'saleNumStr',
          minWidth: 116,
        },
        {
          title: '零售售价金额（含税）',
          key: 'saleAmountStr',
          minWidth: 116,
        },
        {
          title: '零售售价金额（不含税）',
          key: 'saleAmountWithoutTaxStr',
          minWidth: 116,
        },
        {
          title: '盘点盈亏数量',
          key: 'stocktakingNumStr',
          minWidth: 116,
        },
        {
          title: '盘点盈亏金额',
          key: 'stocktakingAmountStr',
          minWidth: 116,
        },
        {
          title: '不合格销毁数量',
          key: 'breakageNumStr',
          minWidth: 116,
        },
        {
          title: '不合格销毁金额',
          key: 'breakageAmountStr',
          minWidth: 116,
        },
        {
          title: '库存数量',
          key: 'inventoryNumStr',
          minWidth: 116,
        },
        {
          title: '库存金额',
          key: 'inventoryAmountStr',
          minWidth: 116,
        },
      ],
      dayTableData: [],
      goodsTableData: [],
      goodsList: [],
      goodsLoading: false,
    };
  },
  computed: {
    addBtnText() {
      if (this.queryType == 'day') {
        return this.handlePermission('invoicingReportByDayExport') ? '导出Excel' : '';
      }
      if (this.queryType == 'goods') {
        return this.handlePermission('invoicingReportByGoodsExport') ? '导出Excel' : '';
      }
      return '';
    },
  },
  methods: {
    handleExport(info, func) {
      let exportFunc = reportService.invoicingListByDayExport;

      // this.params.startTime = this.params.startTime && new Date(this.params.startTime).getTime();
      // this.params.endTime = this.params.endTime && new Date(this.params.endTime).getTime();
      if (this.queryType === 'goods') {
        exportFunc = reportService.invoicingListByGoodsExport;
      }

      this.$store.commit('setDisableLoading', true);
      exportFunc(utils.deletePageAndSize(this.params))
        .then((res) => {
          if (res.data.status === 200) {
            func(res.data.data);
          } else {
            this.$Message.error(res.data.error);
          }
        })
        .catch((err) => {
          utils.handleError(err);
        });
    },
    getTotal() {
      let totalFunc = reportService.invoicingListByDayTotal;
      // this.params.startTime = this.params.startTime && new Date(this.params.startTime).getTime();
      // this.params.endTime = this.params.endTime && new Date(this.params.endTime).getTime();
      if (this.queryType === 'goods') {
        totalFunc = reportService.invoicingListByGoodsTotal;
      }
      totalFunc(utils.deletePageAndSize(this.params)).then((res) => {
        if (res.data.status === 200) {
          this.total = res.data.data || {};
        } else {
          this.$Message.error(res.data.error);
        }
      }).catch((err) => {
        console.log(err);
        utils.handleError(err);
      });
    },
    // fetchGoods(query) {
    //   if (query !== '') {
    //     const data = {
    //       nameMix: query,
    //       page: 1,
    //       size: 5,
    //     };
    //     this.goodsLoading = true;
    //     this.$store.commit('setDisableLoading', true);
    //     goodsService.listGoodsBases(data).then((res) => {
    //       if (res.data.status === 200 && res.data.data.list) {
    //         this.goodsList = res.data.data.list;
    //       } else if (res.data.error) {
    //         this.$Message.error(res.data.error);
    //       }
    //       this.goodsLoading = false;
    //     }).catch((err) => {
    //       utils.handleError(err);
    //     });
    //   } else {
    //     this.goodsList = [];
    //   }
    // },
    clear() {
      this.query = {
        startTime: utils.getCurrentMonthTimestamp(),
        endTime: utils.getNextMonthTimestamp(),
        goodsBaseIdList: [],
        storeIdList: [],
        goodsSerialCode: '',
      };
    },
    getData() {
      this.params.page = this.page;
      this.params.size = this.size;
      // this.params.startTime = this.params.startTime && new Date(this.params.startTime).getTime();
      // this.params.endTime = this.params.endTime && new Date(this.params.endTime).getTime();
      let listFunc = reportService.invoicingListByDay;
      if (this.queryType === 'goods') {
        listFunc = reportService.invoicingListByGoods;
      }

      listFunc(this.params).then((res) => {
        if (res.data.status === 200 && res.data.data.list) {
          let tableName = 'dayTableData';
          if (this.queryType === 'goods') {
            tableName = 'goodsTableData';
          }
          this[tableName] = [];
          this.count = res.data.data.count;
          res.data.data.list.forEach((item) => {
            const result = {};
            utils.exchangeTable(item, result);
            result.createTime = utils.formatTime(result.createTime, 'YYYY-MM-DD');
            if (result.startTime && result.endTime) {
              result.date = `${utils.formatTime(result.startTime, 'YYYY-MM-DD')}至${utils.formatTime(result.endTime, 'YYYY-MM-DD')}`;
            } else {
              result.date = '';
            }
            this[tableName].push(result);
          });
        } else if (res.data.error) {
          this.$Message.error(res.data.error);
        }
      }).catch((err) => {
        utils.handleError(err);
      });
    },
  },
  mounted() {
    this.fetchListIndications();
    this.getLabel();
    this.handleSearch(true, this.getTotal);
    this.getRefreshTime();
  },
};
</script>
<style lang="less" scoped>
  // .btn{
  //   margin-bottom: 12px
  // }
</style>
